import { AppTracker } from 'shared/analytics/tracker';
import { ANALYTIC_V3_EVENTS } from 'views/main/organization/analytics-v3/constants';
import { useGetAnalyticsCountByServiceGroupByPriority } from 'views/main/organization/analytics-v3/hooks/useGetAnalyticsData';
import Empty from 'views/main/organization/analytics-v3/icons/empty';
import { HorizontalStackedBar } from '../../../Charts/Bar/Horizontal';
import Loading from '../../../Charts/Bar/Horizontal/loading';
import Error from 'views/main/organization/analytics-v3/components/Error';
import { AxiosError } from 'axios';
export default function IncidentCountByServiceGroupByPriority({
  isOrgAnalytics = false,
}: {
  isOrgAnalytics?: boolean;
}) {
  const {
    data,
    isLoading,
    isError,
    refetch: refetchCountByServiceGroupByPriority,
    error,
  } = useGetAnalyticsCountByServiceGroupByPriority();
  if (isError)
    return (
      <Error
        onRefreshClick={refetchCountByServiceGroupByPriority}
        errorMessage={(error as AxiosError).response?.data?.message}
      />
    );
  if (isLoading) return <Loading />;
  if (!data) return null;
  const isEmpty = data?.dates.length === 0;
  if (isEmpty) return <Empty />;
  const handleLegendSelect = (name: string) => {
    AppTracker.track(
      ANALYTIC_V3_EVENTS.INCIDENT_ANALYTICS_CHART_LEVEL_FILTER_APPLIED,
      {
        'Analytics Scope': isOrgAnalytics ? 'Organization Analytics' : 'Team Analytics',
        'Analytics Type': 'Incident Analytics',
        'Analytics Tab': 'Incident Analytics',
        'Chart Title': 'Incident Count by Service Group by Priority',
        'Legend Name': name,
      },
      true,
    );
  };
  return (
    <HorizontalStackedBar
      data={{
        dates: data?.dates ?? [],
        series: data?.series ?? [],
      }}
      bottom={100}
      bottomLegend
      onLegendSelect={handleLegendSelect}
    />
  );
}
